module.exports = __webpack_public_path__ + "img/globe-snow.9be3f60b.svg";